export default __webpack_public_path__ + "static/media/loc-material-4.1ed66b33.webp";